"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatEntryNameWithBundlePosition = void 0;
const formatEntryNameWithBundlePosition = (entryName, bundlePosition, bundleSize) => bundlePosition && bundleSize && bundleSize > 1 ? `${entryName} (${bundlePosition}/${bundleSize})` : entryName;
exports.formatEntryNameWithBundlePosition = formatEntryNameWithBundlePosition;
